<ion-row class="th-text" [ngClass]="{ 'alt-background': hasAltBackground }">
  {{ columnText }}
</ion-row>
<ion-row
  class="search-wrapper"
  [ngClass]="{ 'search-wrapper-flex-start': hasAltBackground }"
>
  <form [formGroup]="timeForm">
    <div class="search-header-labels">
      <input
        appTimeInput
        class="input time-picker-input"
        [ngxTimepicker]="picker"
        [formControlName]="'time'"
        [format]="24"
        [disableClick]="true"
        [placeholder]="placeholder"
        (ngModelChange)="onModelChange($event)"
      />
      <ngx-material-timepicker-toggle [for]="picker">
        <ion-icon [src]="icon" ngxMaterialTimepickerToggleIcon></ion-icon>
      </ngx-material-timepicker-toggle>
      <ngx-material-timepicker
        #picker
        [defaultTime]="timeForm.get('time')?.value"
        (change)="onModelChange($event)"
      ></ngx-material-timepicker>
    </div>
  </form>
</ion-row>
